module.exports = __webpack_public_path__ + "img/rejat.845c4c21.jpeg";